module.exports = __webpack_public_path__ + "static/media/purolator.c0700b47.svg";